import { ICreateAndUpdateMunicipality } from "../../../types/common.interface";
import { ICreateAndUpdateSuperAgentProvince } from "../../../types/superAgent.interface";
import customAxios from "../../customAxios";
import { CREATE_SUPER_AGENT_PROVINCE } from "../../routes";

const createSuperAgentProvince = async (
  formData: ICreateAndUpdateSuperAgentProvince
) => {
  try {
    return (
      await customAxios.post(CREATE_SUPER_AGENT_PROVINCE, {
        province: formData.province?._id,
        phoneNumber: formData.phoneNumber,
        name: formData.name,
      })
    ).data;
  } catch (error: unknown) {
    console.error(error);
    return false;
  }
};

export default createSuperAgentProvince;
